var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/auth/ResetPassword/error/ResetPasswordLinkNotValid.tsx";
import React from 'react';
import { Text, VStack } from '@adc/parallax-component-library';
import { Main, ResponsiveContainer } from 'Components/utility';
import i18n from 'Utilities/i18n';
const ResetPasswordLinkNotValid = () => {
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('Global.microcopy.common.libreLogoLight'),
    alt: "",
    id: "Global.microcopy.common.libreLogo",
    style: {
      position: 'absolute',
      zIndex: 1,
      marginTop: '20px',
      width: '100px',
      height: '50px',
      objectFit: 'contain',
      left: '50%',
      transform: 'translateX(-50%)'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 12,
      columnNumber: 7
    }
  }), /*#__PURE__*/React.createElement(ResponsiveContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('LinkNotValid.content.linkNotValidMsg.media.pwResetLockLight'),
    alt: "",
    id: "ResetPasswordLinkNotValid.pwResetLock",
    style: {
      marginTop: '40px',
      height: '105px',
      objectFit: 'contain'
    },
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    marginTop: "$7",
    gridRowGap: "$2",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 38,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordLinkNotValid.title",
    fontWeight: "$h2.strong",
    fontSize: "$h2.strong",
    color: "$text.100",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 11
    }
  }, i18n.t('LinkNotValid.title')), /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordLinkNotValid.primaryText",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    color: "$text.100",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 57,
      columnNumber: 11
    }
  }, i18n.t('LinkNotValid.content.linkNotValidMsg.primaryText'))), /*#__PURE__*/React.createElement(VStack, {
    width: "90%",
    marginHorizontal: "auto",
    marginTop: "$12",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 69,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(Text, {
    nativeID: "ResetPasswordLinkNotValid.secondaryText",
    fontWeight: "$bodyBase.default",
    fontSize: "$bodyBase.default",
    color: "$text.100",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 11
    }
  }, i18n.t('LinkNotValid.content.linkNotValidMsg.secondaryText')))));
};
export default ResetPasswordLinkNotValid;